import { ListType } from 'modules/domains/list';
import { useFiltersContext } from '../../../contexts';

export const useUpdateListType = () => {
  const { setTypes, types } = useFiltersContext();
  const add = (value: ListType) => setTypes([...types, value]);
  const remove = (value: ListType) => setTypes(types.filter((type) => type !== value));
  return (listType: ListType) => (types.includes(listType) ? remove(listType) : add(listType));
};
